import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaExclamationTriangle } from "react-icons/fa";

const ValidationModal = ({ errors, onClose }) => {
  // Add additional descriptive text based on error types
  const getPrimaryFieldHelp = () => {
    const primaryFieldError = errors.find(
      (error) =>
        error.includes("primary field") ||
        error.includes("email field") ||
        error.includes("number input")
    );

    if (primaryFieldError) {
      return (
        <div className="alert alert-info mt-3">
          <small>
            <strong>Tip:</strong> The primary field must be either an email
            field or a number input field. Please ensure your form contains at
            least one such field properly labeled.
          </small>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <Modal.Body>
        <div className="text-center mb-4">
          <FaExclamationTriangle size={48} className="text-warning mb-3" />
          <h5>Please fix the following issues before saving:</h5>
          <div className="mt-4 text-left">
            <ul className="list-group">
              {errors.map((error, index) => (
                <li key={index} className="list-group-item text-danger">
                  {error}
                </li>
              ))}
            </ul>
            {/* {getPrimaryFieldHelp()} */}
          </div>
        </div>
      </Modal.Body>
    </>
  );
};

export default ValidationModal;
